/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface APIHumanReadableDuration
 */
export interface APIHumanReadableDuration {
    /**
     * 
     * @type {number}
     * @memberof APIHumanReadableDuration
     */
    months: number;
    /**
     * 
     * @type {number}
     * @memberof APIHumanReadableDuration
     */
    weeks: number;
    /**
     * 
     * @type {number}
     * @memberof APIHumanReadableDuration
     */
    days: number;
}

/**
 * Check if a given object implements the APIHumanReadableDuration interface.
 */
export function instanceOfAPIHumanReadableDuration(value: object): value is APIHumanReadableDuration {
    if (!('months' in value) || value['months'] === undefined) return false;
    if (!('weeks' in value) || value['weeks'] === undefined) return false;
    if (!('days' in value) || value['days'] === undefined) return false;
    return true;
}

export function APIHumanReadableDurationFromJSON(json: any): APIHumanReadableDuration {
    return APIHumanReadableDurationFromJSONTyped(json, false);
}

export function APIHumanReadableDurationFromJSONTyped(json: any, ignoreDiscriminator: boolean): APIHumanReadableDuration {
    if (json == null) {
        return json;
    }
    return {
        
        'months': json['months'],
        'weeks': json['weeks'],
        'days': json['days'],
    };
}

export function APIHumanReadableDurationToJSON(value?: APIHumanReadableDuration | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'months': value['months'],
        'weeks': value['weeks'],
        'days': value['days'],
    };
}

